import React, { useCallback, useState } from 'react';
import AdminPortalTable from '../../containers/AdminPortalTableContainer/AdminPortalTableContainer';
import ProductManagementFilterBar from '../../containers/ProductManagementFilterBar/ProductManagementFilterBar';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import AdminPortalSideBar from '../../containers/AdminSideBarContainer/AdminSideBarContainer';
import { PageContainer, ContentContainer } from './AdminPortalPage.styles';

export default function AdminPortalPage() {
  const [tabIndex, setTabIndex] = useState(0);
  const [filters, setFilters] = useState({});

  const handleFilterChange = useCallback((f) => {
    setFilters(f || {});
  }, []);

  const handleNew = useCallback(() => {
    window.dispatchEvent(new CustomEvent('apd:create-product'));
  }, []);

  return (
    <>
      <TopNavbar onTabChange={setTabIndex} />
      <PageContainer>
        <AdminPortalSideBar />
        <ContentContainer>
          <ProductManagementFilterBar
            value={filters} 
            onChange={handleFilterChange}
            onNew={handleNew}
          />
          <AdminPortalTable filters={filters} tabIndex={tabIndex} />
        </ContentContainer>
      </PageContainer>
    </>
  );
}
